import { Link } from "react-router-dom";
import { ArrowRight, Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { DailyBriefSignup } from "@/components/home/DailyBriefSignup";
import { sectorTrack } from "./SectorHero";

export const SectorClose = ({ sector = "crypto", label = "crypto" }: { sector?: string; label?: string }) => {
  const { user } = useAuth() as any;
  const isPremium = !!user?.is_premium;
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-12" data-testid="sector-close">
      <div className="grid lg:grid-cols-[minmax(0,1fr)_380px] gap-4 items-stretch">
        <DailyBriefSignup sourceType={`sector_${sector}`} className="!mt-0" />
        <div className="rounded-xl border border-[#7C3AED]/40 bg-gradient-to-br from-[#7C3AED]/[0.12] to-transparent p-5 sm:p-6 flex flex-col"
          data-testid="sector-premium-panel">
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.28em] text-[#A78BFA] flex items-center gap-1.5">
            <Crown aria-hidden className="h-3.5 w-3.5" />
            {isPremium ? "Your Premium Access" : "Go Deeper"}
          </p>
          <p className="font-heading font-bold text-white text-lg leading-snug mt-2.5">
            {isPremium
              ? `Premium unlocked — explore member-only ${label} intelligence.`
              : `Unlock premium ${label} intelligence, deep dives and member-only analysis.`}
          </p>
          <Link to={isPremium ? "/premium" : "/premium"} data-testid="sector-premium-cta"
            onClick={() => sectorTrack("premium_cta", isPremium ? "explore" : "upgrade", sector)}
            className="group mt-auto pt-4 inline-flex items-center gap-2 font-mono text-[12px] font-bold text-[#00E5FF] hover:text-white transition-colors">
            {isPremium ? "Explore Premium" : "Go Premium"}
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>
    </section>
  );
};
